import { GoogleSignIn } from '~/auth-flow/google-sign-in';
import { onNextRepaint } from '~/shared/utils/animation';
import { AuthScreen } from './base-auth-screen';

export class SignupAuthScreen extends AuthScreen {
  constructor(screen) {
    super(screen);

    GoogleSignIn.registerLoadCallback(this.renderGoogleSignInButton.bind(this));
  }

  renderGoogleSignInButton() {
    const googleButtonContainer = this.screen.querySelector('[data-google-sign-in-button]');
    if (!googleButtonContainer) return;

    const fadeInGoogleButton = () => {
      onNextRepaint(() => {
        googleButtonContainer?.toggleAttribute('data-google-fade-in', true);
      });
    };

    // Each Google Sign-In button should have a unique `state` string to identify it.
    // This let's us know if the user logged in via a "Sign in with Google" button
    // in the auth flow or via the One Tap prompt (which would not have a state).
    // https://developers.google.com/identity/gsi/web/reference/js-reference#google.accounts.id.renderButton
    const googleState = googleButtonContainer.getAttribute('data-google-sign-in-button');

    // Fade in the Google button when the "fake google sign-in button" is removed
    // from the DOM to keep the UX feeling smooth. This only occurs on desktop
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.removedNodes.length > 0) fadeInGoogleButton();
      }
    });

    observer.observe(googleButtonContainer, { childList: true, subtree: true });

    window.google.accounts.id.renderButton(googleButtonContainer, {
      size: 'large',
      theme: 'outline',
      shape: 'circle',
      width: '310',
      text: 'continue_with',
      state: googleState,
    });

    // On mobile (where Google doesn't use the iFrame button and uses the "fake one")
    // we can ensure it fades in after a short delay
    setTimeout(() => {
      fadeInGoogleButton();
      observer.disconnect();
    }, 600);
  }
}
